import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  ApiConfig
} from "./chunk-IITKCRXL.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/auth/logout.ts
import { Exception } from "@wbk/logger";
var logout = () => __async(null, null, function* () {
  var _a, _b;
  try {
    yield fetchClient({
      url: "/auth/logout",
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi,
      options: {
        method: "POST"
      }
    });
    return true;
  } catch (error) {
    throw new Exception({ error, name: "logoutException" });
  }
});

export {
  logout
};
//# sourceMappingURL=chunk-USNUKULP.mjs.map